import { IStore } from 'store/configureStore';

export const selectCreateCustomFieldState = (state: IStore) => state.modules.settings.customFields.customFieldCreate;
export const selectIsCreateCustomFieldModalOpened = (state: IStore) => selectCreateCustomFieldState(state).isOpen;
export const selectIsCreatingCustomField = (state: IStore) => selectCreateCustomFieldState(state).isCreating;
